
















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {AppealCustomFields} from "@/models/appeals";
import TimePicker from "@/components/hoc/TimePicker.vue";
import moment from "moment";


@Component({
  inject: ['form'],
  components: {TimePicker},
  computed: {
    hasError() {
      return this.errors.length > 0 || (this.empty && this.required);
    },
  },
  watch:{
    errorMessages(e) {
      if (e == "") {
        this.errors = [];
        this.validate();
      } else {
        this.errors = [e];
      }
    },
  },
  data() {
    return {
      errors: [],
    };
  }
})
class TimeCustomField extends Vue {
  [x: string]: any;

  @Prop({ required: true }) readonly item!: AppealCustomFields;
  @Prop({ default: "" }) readonly fieldName!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: () => [] }) errorMessages: any;

  empty = true;

  created() {
    this.empty = true;
    this.form && this.form.register(this);
  }
  beforeDestroy () {
    this.form && this.form.unregister(this)
  }
  time = "";

  validate() {
    this.errors = (this.time || "") != "" || !this.required ? [] : ["Заполните данное поле"];
  }

  getErrors(): string | string[] {
    return this.errors;
  }

  @Watch("time")
  timeChanged() {
    this.empty = false;
    this.item['значение'] = moment().format('DD.MM.YYYY') + " " + this.time + ":00";
    this.item['ошибка'] = "";
    this.validate();
  }
}

export default TimeCustomField;
